module.exports = __webpack_public_path__ + "img/360.03320ec4.png";